import { ChipNavigationMui, ChipNavigationProps } from '@mi-front/ui';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import WarningIcon from '@mui/icons-material/Warning';
import { Alert, Box } from '@mui/material';
import { useIntl } from 'react-intl';
import { ReportResultProps } from '../../../../../../../../core/reports/types';
import { UnverifiedBcrEntriesTable } from './components/UnverifiedBcrEntriesTable';
import { UnverifiedMatchesTable } from './components/UnverifiedMatchesTable';
import { VerifiedMatchesTable } from './components/VerifiedMatchesTable';
import { BcrMatchesReport } from './types';

export function BcrMatchesReportResult(p: ReportResultProps<BcrMatchesReport>) {
  const { $t } = useIntl();
  const { verified, unverifiedMatches, unverifiedBcrEntries, meta } = p.result;

  const chips: ChipNavigationProps['chips'] = [
    {
      value: 'verified',
      label: `${$t({
        id: 'audit.reportsScreen.bcrMatches.tabs.verified',
        defaultMessage: 'Matches verificados',
      })} (${verified.length})`,
      icon: <CheckIcon />,
      content: <VerifiedMatchesTable data={verified} />,
    },
    {
      value: 'unverified-matches',
      label: `${$t({
        id: 'audit.reportsScreen.bcrMatches.tabs.unverifiedMatches',
        defaultMessage: 'Matches sin verificar',
      })} (${unverifiedMatches.length})`,
      icon: <CloseIcon />,
      color: 'warning' as const,
      content: <UnverifiedMatchesTable data={unverifiedMatches} />,
    },
    {
      value: 'unverified-bcr-entries',
      label: `${$t({
        id: 'audit.reportsScreen.bcrMatches.tabs.unverifiedBcrEntries',
        defaultMessage: 'Entradas BCR sin verificar',
      })} (${unverifiedBcrEntries.length})`,
      icon: <WarningIcon />,
      color: 'warning' as const,
      content: <UnverifiedBcrEntriesTable data={unverifiedBcrEntries} />,
    },
  ];

  return (
    <Box>
      {meta?.missingBcrEntries && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          {$t({
            id: 'audit.reports.bcrMatches.noBcrEntries',
            defaultMessage: 'No se encontraron entradas BCR para el reporte',
          })}
        </Alert>
      )}
      <ChipNavigationMui
        chips={chips}
        defaultActiveChip="verified"
        ContentWrapper={(p) => <Box mt={2} {...p} />}
      />
    </Box>
  );
}
